/** Ana sayfa tabloları — varsayılan sayfa boyutu */
export const PAGE_DEFAULT_LIMIT = 25;

/** Modal / detay listeleri */
export const MODAL_DEFAULT_LIMIT = 10;

/** Satır seçicili sayfalarda seçenekler */
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

/** Servis Kaydı Takip listesi */
export const SERVICE_RECORD_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 75, 100];

/** UserManagement gibi dar seçenekli sayfalar */
export const ROWS_PER_PAGE_OPTIONS_NARROW = [10, 25, 50];
